import { useCallback, useEffect, useRef } from 'react';
import { useIsMobileDimension } from '@carnica/utils/hooks';
var isInRange = function isInRange(first, second) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return first + offset >= second && first - offset <= second;
};
var getScrollPosition = function getScrollPosition(container) {
  return {
    x: container instanceof Window ? container.scrollX : container.scrollLeft,
    y: container instanceof Window ? container.scrollY : container.scrollTop
  };
};
export var useCloseOnScroll = function useCloseOnScroll(_ref) {
  var isActive = _ref.isActive,
    container = _ref.container,
    callback = _ref.callback,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? 50 : _ref$offset;
  var containerRef = useRef(null);
  var initialCoords = useRef({
    x: 0,
    y: 0
  });
  var isMobile = useIsMobileDimension();
  var event = isMobile ? 'touchmove' : 'scroll';
  useEffect(function () {
    var element = container && 'current' in container ? container.current : container;
    containerRef.current = element || window;
  }, []);
  var listener = useCallback(function (e) {
    var scrollContainer = containerRef.current;
    if (!scrollContainer) {
      return;
    }
    var _initialCoords$curren = initialCoords.current,
      x = _initialCoords$curren.x,
      y = _initialCoords$curren.y;
    var scroll = getScrollPosition(scrollContainer);
    if (!isInRange(x, scroll.x, offset) || !isInRange(y, scroll.y, offset)) {
      callback === null || callback === void 0 ? void 0 : callback(e, 'scroll');
    }
  }, [offset]);
  useEffect(function () {
    var scrollContainer = containerRef.current;
    if (isActive && scrollContainer) {
      scrollContainer.addEventListener(event, listener);
      initialCoords.current = getScrollPosition(scrollContainer);
    }
    return function () {
      scrollContainer === null || scrollContainer === void 0 ? void 0 : scrollContainer.removeEventListener(event, listener);
    };
  }, [isActive, event]);
};